import { useState, useEffect, ChangeEvent } from "react";
import styled from "styled-components";
import DeleteButton from "../components/delete-button";
import PrimaryButton from "../components/primary-button";
import Row from "../components/row";
import { Table } from "../models/post";

const TableColumn = styled.div`
    display: grid;
    gap: 1px;
    background-color: #EEEEEE;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #EEEEEE;
    width: 100%;
`;

const TableCell = styled.div`
    width: 100%;
    padding: 0.5rem;
    background-color: white;
`;
const HorizontalCenter = styled.div`
    display: grid;
    gap: 0.5rem;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
`;

const TextInput = styled.input`
    appearance: none;
    border: none;
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
    width: 100%;
    &::placeholder {
		color: rgb(200,200,200);
	}
	&:focus {
		outline: none;
	}
`;

export default function TableComponent(props: { table: Table, update: (columns: string[][]) => void, deleteContent: () => void }) {
    const [columns, setColumns] = useState(props.table.columns as string[][]);
	const [showDelete, setShowDelete] = useState(false);

    const addColumn = () => {
        if (columns.length < 4)
            setColumns(c => [...c, (c[0] as string[]).map(s => '')] as string[][]);
    };

    const addRow = () => {
        setColumns(c => c.map(s => [...(s as string[]), ''] as string[]));
    };

    const deleteRow = () => {
        if ((columns[0] as string[]).length > 1)
            setColumns(c => c.map(s => [...(s as string[])].filter((e, i) => i < (s as string[]).length-1)));
    };

    const deleteColumn = () => {
        if (columns.length > 1)
            setColumns(c => [...(c as string[][])].filter((e, i) => i < c.length-1));
    };

    const updateCell = (e: ChangeEvent<HTMLInputElement>, col: number, row: number) => {
        const c = [...columns.map(c => [...(c as string[])])];
        (c as string[][])[col][row] = e.target.value;
        setColumns(c);
    };

    useEffect(() => {
        props.update(columns as string[][]);
    }, [props, columns]);
    return <>
        <HorizontalCenter>
            {columns.map((c, col) => <TableColumn key={col}>
                {(c as string[]).map((s, row) => <TableCell key={row}><TextInput value={columns[col][row]} onChange={e => updateCell(e, col, row)} placeholder="Inhalt" /></TableCell>)}
            </TableColumn>)}
        </HorizontalCenter>
        <Row>
            <DeleteButton onClick={deleteColumn}>
                Spalte löschen
            </DeleteButton>
            <PrimaryButton onClick={addColumn}>
                Spalte hinzufügen
            </PrimaryButton>
        </Row>
        <Row>
            <DeleteButton onClick={deleteRow}>
                Reihe löschen
            </DeleteButton>
            <PrimaryButton onClick={addRow}>
                Reihe hinzufügen
            </PrimaryButton>
        </Row>
        
    </>
}